import { CampaignSection, CheckoutSection } from 'server/types/pmts-overrides';

export function migrateCampaignSections(sections: CampaignSection[]): CheckoutSection[] {
  return sections.map((section): CheckoutSection => {
    switch (section.type) {
      case 'hero':
        return {
          type: 'hero',
          settings: {
            gradientFrom: '#0077cc',
            gradientTo: '#001a6e',
          },
          content: {
            headline: section.headline,
            subtitle: section.subtitle,
            logoUrl: section.logoUrl,
            priceBadgeText: section.badge,
          },
        };

      case 'benefits':
        return {
          type: 'valueStack',
          content: {
            heading: section.heading,
            items: section.items,
          },
        };

      case 'content':
        return {
          type: 'content',
          settings: { maxWidth: 'wide' as const },
          content: {
            blocks: [{ type: 'html', html: section.html }],
          },
        };

      case 'faq':
        return {
          type: 'faq',
          content: {
            heading: section.heading,
            items: section.items,
          },
        };

      case 'urgency':
        return {
          type: 'urgency',
          content: { text: section.text },
        };

      case 'instructor':
        return {
          type: 'instructor',
          content: {
            name: section.name,
            title: section.title,
            photoUrl: section.photoUrl,
            bio: section.bio,
          },
        };

      case 'footer':
        return {
          type: 'footer',
          content: {
            logoUrl: section.logoUrl,
            disclaimerHtml: section.disclaimerHtml,
            contactPhone: section.contactPhone,
            contactEmail: section.contactEmail,
          },
        };

      case 'checkout':
        return {
          type: 'integratedCheckout',
          content: {
            pricingNote: section.pricingNote,
            deadlineText: section.deadlineText,
            contactPhone: section.contactPhone,
            contactEmail: section.contactEmail,
            testimonials: section.testimonials,
          },
        };
    }
  });
}
